import { rtlDir } from '../constants';

export const LOG_LEVEL = {
  INFO: 'INFO',
  ERROR: 'ERROR',
  DEBUG: 'DEBUG'
};

export const TRANSACTION_STATE = {
  NO_TRANSACTION: 'NO_TRANSACTiON',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL'
};

export const INIT_APP = 'INIT_APP';
export const SEND_NPS = 'SEND_NPS';
export const SET_APP_INITIALIZED = 'SET_APP_INITIALIZED';

export const SET_INTERFACE_LANGUAGE = 'SET_INTERFACE_LANGUAGE';
export const SET_PREFERENCES = 'SET_PREFERENCES';
export const SET_TARGET_LANGUAGE = 'SET_TARGET_LANGUAGE';
export const LOG_EVENT = 'LOG_EVENT';

const SET_LAST_TRANSACTION_STATE = 'SET_LAST_TRANSACTION_STATE';

export const LOGIN_USER = 'APP_LOGIN_USER';
export const LOGOUT_USER = 'APP_LOGOUT_USER';

export const SET_LOGOUT_VALIDATION = 'SET_LOGOUT_VALIDATION';

const SET_UNSUPPORTED_BROWSER = 'SET_UNSUPPORTED_BROWSER';
const SET_UNSUPPORTED_ORIGIN_URL = 'SET_UNSUPPORTED_ORIGIN_URL';

const SET_LOCALIZATIONS_PATH = 'SET_LOCALIZATIONS_PATH';
const SET_INTERFACE_LANGUAGE_DIRECTION = 'SET_INTERFACE_LANGUAGE_DIRECTION';

// initial state object
const initialAppState = {
  appId: 'launchpad',
  isInitialized: false,
  localizationsPath: '',
  interfaceLanguageDirection: 'ltr',
  showLogoutWarning: false,
  logoutWarningHeader: '',
  logoutWarningBody: '',
  lastTransactionState: TRANSACTION_STATE.NO_TRANSACTION,
  lastTransactionError: '',
  unsupportedBrowser: false,
  unsupportedOriginUrl: ''
};

export const appReducer = (appState = initialAppState, action = null) => {
  switch (action && action.type) {
    // those which just want sagas
    case INIT_APP:
    case LOGIN_USER:
    case LOGOUT_USER:
    case LOG_EVENT:
    case SEND_NPS:
    case SET_INTERFACE_LANGUAGE:
    case SET_PREFERENCES:
    case SET_TARGET_LANGUAGE:
      return appState;

    case SET_APP_INITIALIZED:
      return {
        ...appState,
        isInitialized: true
      };

    case SET_LAST_TRANSACTION_STATE:
      let errorMsg = action.payload.errorMsg;
      if (typeof errorMsg === 'undefined' || action.payload.transactionState !== TRANSACTION_STATE.FAIL) {
        errorMsg = '';
      }
      return {
        ...appState,
        lastTransactionState: action.payload.transactionState,
        lastTransactionError: errorMsg
      };

    case SET_LOCALIZATIONS_PATH:
      return {
        ...appState,
        localizationsPath: action.payload.localizationsPath
      };

    case SET_INTERFACE_LANGUAGE_DIRECTION:
      return {
        ...appState,
        interfaceLanguageDirection: action.payload.interfaceLanguageDirection
      };

    case SET_LOGOUT_VALIDATION:
      return {
        ...appState,
        showLogoutWarning: action.payload.showLogoutWarning,
        logoutWarningHeader: action.payload.logoutWarningHeader,
        logoutWarningBody: action.payload.logoutWarningBody
      };

    case SET_UNSUPPORTED_BROWSER:
      return {
        ...appState,
        unsupportedBrowser: action.payload
      };

    case SET_UNSUPPORTED_ORIGIN_URL:
      return {
        ...appState,
        unsupportedOriginUrl: action.payload
      };

    default:
      return appState;
  }
};

//******************************
export const appActions = {
  initApp: () => ({ type: INIT_APP }),
  sendNps: (score) => ({
    type: SEND_NPS,
    payload: { score: score }
  }),
  setAppInitialized: () => ({ type: SET_APP_INITIALIZED }),
  setLocalizationsPath: (localizationsPath) => ({ type: SET_LOCALIZATIONS_PATH, payload: { localizationsPath } }),
  setInterfaceLanguageDirection: (interfaceLanguageDirection) => ({
    type: SET_INTERFACE_LANGUAGE_DIRECTION,
    payload: { interfaceLanguageDirection }
  }),
  loginUser: (username, password, token) => ({
    type: LOGIN_USER,
    payload: { username: username, password: password, token: token }
  }),
  loginUserWithToken: (token, password) => ({ type: LOGIN_USER, payload: { token: token } }),
  logoutUser: () => ({ type: LOGOUT_USER, payload: {} }),
  setInterfaceLanguage: (languageCode) => ({ type: SET_INTERFACE_LANGUAGE, payload: { languageCode } }),
  setLogoutValidation: (showOnLogout, heading, message) => ({
    type: SET_LOGOUT_VALIDATION,
    payload: { showLogoutWarning: showOnLogout, logoutWarningHeader: heading, logoutWarningBody: message }
  }),
  setPreferences: () => ({ type: SET_PREFERENCES, payload: {} }),
  setUserTargetLanguage: (languageCode) => ({ type: SET_TARGET_LANGUAGE, payload: { languageCode } }),
  logEvent: (event) => ({ type: LOG_EVENT, payload: event }),
  setLastTransactionState: (transactionState, errorMsg) => ({
    type: SET_LAST_TRANSACTION_STATE,
    payload: { transactionState: transactionState, errorMsg: errorMsg }
  }),
  setUnsupportedBrowser: (unsupported) => ({ type: SET_UNSUPPORTED_BROWSER, payload: unsupported }),
  setUnsupportedOriginUrl: (url) => ({ type: SET_UNSUPPORTED_ORIGIN_URL, payload: url })
};

//******************************
export const appSelectors = {
  isAppInitialized: (state) => state.app.isInitialized,
  appId: (state) => state.app.appId,
  localizationsPath: (state) => state.app.localizationsPath,
  isInterfaceRtl: (state) => state.app.interfaceLanguageDirection === rtlDir,
  showLogoutWarning: (state) => state.app.showLogoutWarning,
  logoutWarningHeader: (state) => state.app.logoutWarningHeader,
  logoutWarningBody: (state) => state.app.logoutWarningBody,
  lastTransactionState: (state) => state.app.lastTransactionState,
  lastTransactionError: (state) => state.app.lastTransactionError,
  getUnsupportedBrowser: (state) => state.app.unsupportedBrowser,
  getUnsupportedOriginUrl: (state) => state.app.unsupportedOriginUrl
};



// WEBPACK FOOTER //
// ./src/modules/app/reducer/app-reducer.js